import { render, staticRenderFns } from "./PriceOff.vue?vue&type=template&id=b9b75758"
import script from "./PriceOff.vue?vue&type=script&lang=js"
export * from "./PriceOff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports